import Vue from 'vue';
import App from './App.vue';
import { router } from '@/router';
import ConfigProvider from './config/ConfigProvider';
import { httpService } from './services/HttpService';
import { logService } from '@/services/LogService';
import { toastService } from "./services/ToastService";
import UsuarioPopup from './views/Usuario/UsuarioPopup.vue';
import SorteoPopup from './views/Sorteo/SorteoPopup.vue';

import { locale, loadMessages } from 'devextreme/localization';
import Vuetify from 'vuetify';
import es from 'vuetify/src/locale/es'
import moment from "moment";
import ScrollLoader from 'vue-scroll-loader';
import VueScrollPicker from "vue-scroll-picker"

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import 'vuetify/dist/vuetify.min.css';
import "vue-scroll-picker/dist/style.css"
import '@/assets/custom.css'

var esMessages = require('devextreme/localization/messages/es.json');
loadMessages(esMessages);
locale(navigator.language)

Vue.use(Vuetify, {
  lang: {
    locales: { es },
    current: 'es'
  }
})

moment.locale('es');
Vue.use(require('vue-moment'));
Vue.use(ScrollLoader);
Vue.use(VueScrollPicker);

httpService.root = ConfigProvider.value('endpointAPI');
logService.app = <string>process.env.VUE_APP_NAME;
Vue.config.productionTip = false;

Vue.component("UsuarioPopup", UsuarioPopup);
Vue.component("SorteoPopup", SorteoPopup);

Vue.config.errorHandler = function (err, vm, info)  {
  logService.Error(err+" "+info, vm.$vnode.tag, null, err) 
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

toastService.initEventListener();

logService.Info("Web iniciada");